module.exports = __webpack_public_path__ + "images/pages/for_business/sp/fv_25c7b4885de39618417d281fb904682b.jpg";